import { render } from "./Simplebar.vue?vue&type=template&id=22da6db0"
import script from "./Simplebar.vue?vue&type=script&lang=js"
export * from "./Simplebar.vue?vue&type=script&lang=js"

import "simplebar/dist/simplebar.min.css?vue&type=style&index=0&lang=css"
script.render = render

export default script